import {mergeWith} from 'lodash'
import moment from 'moment'

import React from 'react'
import {SearchToSelect} from '../../../components'

export default function (angularModule) {
  angularModule.controller('invoicingEditorCtrl',
    (
      $scope,
      invoicingConfigService,
      accountsService,
      $uibModalInstance,
      $q,
      billingAccount
    ) => {

      $scope.allAccounts = []
      $scope.accounts = []
      $scope.selectedAccount = null
      $scope.selectedLocation = null
      $scope.loading = true;

      $scope.SearchToSelect = SearchToSelect

      const addLocation = (location) => {
        $scope.config.chargeSeparately.push({
          entity: {entityType: "Location", id: location.locationId.replace("legacy-", ""), name: location.summary},
          chargifySubscriptionId: ""
        })

        $scope.form.configForm.$dirty = true

        refreshEntitiesChargedSeparately()
      }

      const addAccount = (account) => {
        $scope.config.chargeSeparately.push({
          entity: {entityType: "Account", id: account.id, name: account.accountName},
          chargifySubscriptionId: ""
        })

        $scope.form.configForm.$dirty = true

        refreshEntitiesChargedSeparately()
      }

      $scope.locationSelectorProps = {
        getSearchResults: ({query}) => {
          const currentLocationIds = ($scope.locationsChargedSeparately || []).map(l => l.entity.id)

          return invoicingConfigService.getBillingAccountLocations(billingAccount._id, currentLocationIds, query, 100)
            .then(locations => locations.filter(x => !x._deleted))
        },
        options: $scope.billingAccountLocations,
        renderOption: location => (<div key={location.locationId}>{location.summary}</div>),
        getKey: location => location['locationId'],
        placeholder: 'Select a location to invoice separately.',
        disableCaching: true,
        onSelected: addLocation
      }

      $scope.accountSelectorProps = {
        getSearchResults: ({query}) => {
          const currentAccountIds = ($scope.accountsChargedSeparately || []).map(l => l.entity.id)

          return $scope.allAccounts
            .filter(account => !query || account.accountName.toLowerCase().includes(query.toLowerCase()))
            .filter(account => !currentAccountIds.includes(account.id))
        },
        options: $scope.allAccounts,
        renderOption: account => (<div key={account.id}>{account.accountName}</div>),
        getKey: account => account['id'],
        placeholder: 'Select an account to invoice separately.',
        disableCaching: true,
        onSelected: addAccount
      }

      // Example invoice config object
      // $scope.config = {
      //   _id: "5b524e8c31f3b90cfe056bd5",
      //   billingAccountId: "5792afcfd4c6c755215ca7dd",
      //   monthlyMinimum: 1,
      //   chargifySubscriptionId: "",
      //   chargeSeparately: [{
      //     entity: {entityType: "Account", id: "2249", name: "QA Test"},
      //     chargifySubscriptionId: "4567"
      //   }]
      // }

      const getAccounts = () => {
        return accountsService
          .listAccounts({
            accountId: billingAccount.primaryAccountId,
            showSubAccounts: true
          })
          .then(resp => resp.accounts)
      }

      function load() {
        $scope.isLoading = true;
        const dataLoad = {
          invoicingConfig: invoicingConfigService.get(billingAccount._id),
          lastInvoice: invoicingConfigService.getLastInvoice(billingAccount._id),
          accounts: getAccounts(),
          locations: invoicingConfigService.getBillingAccountLocations(billingAccount._id),
        }


        return $q.all(dataLoad)
          .then(({
                   invoicingConfig,
                   lastInvoice,
                   accounts,
                   locations,
                 }) => {
            $scope.config = invoicingConfig

            $scope.lastInvoice = lastInvoice
            $scope.lastInvoice.invoices = (lastInvoice.primaryInvoice ? [lastInvoice.primaryInvoice] : [])
              .concat(lastInvoice.secondaryInvoices)
              .map(x => {
                return {...x, original: x}
              });

            refreshEntitiesChargedSeparately()

            if(accounts.length > 1){
              for (let i = 0; i < accounts.length; i++) {
                let account = accounts[i];
                if (!account.parentAccountId) {
                  accounts.splice(i, 1);
                  accounts.unshift(account);
                }
              }
            }
            $scope.allAccounts = accounts
            $scope.allLocations = locations

            // Add account name to accounts for ui
            $scope.accountsChargedSeparately.forEach(entity => {
              const maybeAccount = $scope.allAccounts.find(allAccount => {
                return entity.entity.id === allAccount.id
              })

              if (maybeAccount) {
                entity.entity.name = maybeAccount.accountName
              }
            })

            // Add location name to accounts for ui
            $scope.locationsChargedSeparately.forEach(entity => {
              const maybeLocation = $scope.allLocations.find(allLocation => {
                return entity.entity.id === allLocation.locationId.replace("legacy-", "")
              })

              if (maybeLocation) {
                entity.entity.name = maybeLocation.summary
              }
            })

            filterAccountsWithoutChargifySubscriptionIds()
            $scope.selectedAccount = $scope.accounts[0]
            $scope.loading = false;
          })
      }
      load();

      const refreshEntitiesChargedSeparately = () => {
        $scope.accountsChargedSeparately = $scope.config.chargeSeparately.filter(chargedSeparately => chargedSeparately.entity.entityType === "Account")

        $scope.locationsChargedSeparately = $scope.config.chargeSeparately.filter(chargedSeparately => chargedSeparately.entity.entityType === "Location")
      }

      const filterAccountsWithoutChargifySubscriptionIds = () => {
        $scope.accounts = $scope.allAccounts.filter((account) => {
          return $scope.accountsChargedSeparately.find(entity => {
            return account.id === entity.entity.id
          }) === undefined
        })
      }

      $scope.syncInvoice = () => {
        $scope.isSyncing = true
        $scope.syncError = false
        $scope.syncSuccess = false
        invoicingConfigService.syncNow({ billingAccountId: billingAccount._id })
          .then(() => {
            $scope.syncSuccess = true
          })
          .catch(ex => {
            console.error("failed to sync", ex);
            $scope.syncError = true;
          })
          .finally(() => {
            $scope.isSyncing = false;
          })
          .then(() => {
            $scope.isSyncing = false;
            return load()
          })
      }
      $scope.printDate = (dateObject) => {
        return dateObject ? moment(dateObject && dateObject.$date || dateObject).format('YYYY-MM-DD') : ''
      }

      $scope.cancel = () => {
        $uibModalInstance.dismiss('Cancel Button');
      };

      $scope.hideValidationError = () => {
        delete $scope.validationOrUpdateError
      }
      $scope.save = () => {
        $scope.saving = true

        const overrides = $scope.lastInvoice.invoices
          .filter(x => {
            return x.minimumDiffChargesCents !== x.original.minimumDiffChargesCents ||
              x.locationBasedChargesCents !== x.original.locationBasedChargesCents
          })
          .map(x => invoicingConfigService.overrideInvoice({
            invoice_id: x.invoice_id,
            statement_id: x.statement_id,
            locationBasedChargesCents: x.locationBasedChargesCents,
            minimumDiffChargesCents: x.minimumDiffChargesCents
          }));
        $q.all([invoicingConfigService.save($scope.config)].concat(overrides))
          .then(() => load())
          .then(() => {
            $scope.saving = false
          })
          .catch(ex => {
            $scope.saving = false
            let unwrapped = ex
            if (unwrapped.data) {
              unwrapped = unwrapped.data;
            }
            if (unwrapped.message) {
              unwrapped = unwrapped.message;
            }
            $scope.validationOrUpdateError = unwrapped
          })
      }

      $scope.removeEntityChargedSeparately = (entityType, entityId) => {

        const entityIndex = $scope.config.chargeSeparately.findIndex(item => (item.entity.entityType === entityType && item.entity.id === entityId))

        $scope.config.chargeSeparately.splice(entityIndex, 1)

        $scope.form.configForm.$dirty = true

        refreshEntitiesChargedSeparately()
        filterAccountsWithoutChargifySubscriptionIds()
      }

      $scope.runJob = (invoiceNow) => {
        // invoicingConfigService.get()
      }
  })
};


function deepMerge(object, other) {
  return mergeWith(object, other, (objValue, srcValue) => {
    // normal lodash merge merges by index. Just do a shallow array merge like server does
    if (Array.isArray(objValue)) {
      return srcValue
    }
  })
}

function deepMergeAll(...args) {
  return args.reduce(deepMerge,{})
}
